/**
 * Catalogue des actions rapides de l'assistant vocal (MOKA-206 Phase 3,
 * étendu MOKA-207 Phase 4 Lot 4). Sert à la fois la palette « / »
 * (`SlashCommandPaletteComponent`) et les chips affichées sous le message
 * d'accueil du fil de conversation (`VoiceChatThreadComponent`) — une seule
 * source pour les deux points d'entrée, avec `primary` qui distingue les
 * actions mises en avant en chips (5 max, cf. règle produit) des actions
 * secondaires accessibles seulement via la palette.
 *
 * Choix des 5 chips primary (Lot 4) : les actions les plus fréquentes au
 * quotidien (consultation ET écriture rapide) — `myTasks` (point d'entrée
 * "check du matin"), `createTask`, `addToCalendar` (poser une présence),
 * `assignTask`, `reserveRoom`. `createProject` passe en secondaire (moins
 * fréquent qu'une simple tâche) ; les autres actions ajoutées par ce lot
 * (`projectSummary`, `commentTask`, `reportClaim`) restent des lectures/
 * écritures ponctuelles, pas assez fréquentes pour une chip visible.
 *
 * `addToCalendar` — libellé renommé "Poser une présence" (Lot 4) pour
 * matcher le vocabulaire produit ; le flow (`VoiceGuidedFlowService`) et
 * l'endpoint (`calendar.addPresences`) sont inchangés, aucun doublon créé
 * avec la nouvelle action demandée sous ce nom.
 */

/** Identifiant d'un flow guidé, consommé par `VoiceGuidedFlowService` */
export type QuickActionFlow =
  | 'createTask'
  | 'createProject'
  | 'assignTask'
  | 'addToCalendar'
  | 'updateTaskStatus'
  | 'deleteTask'
  | 'myTasks'
  | 'projectSummary'
  | 'commentTask'
  | 'reserveRoom'
  | 'reportClaim';

export interface QuickActionDef {
  id: QuickActionFlow;
  label: string;
  /** Nom d'icône `@ng-icons/iconoir` (sans le préfixe `iconoir`, cf. usage dans les templates) */
  icon: string;
  /** true = action mise en avant (chip sous le message d'accueil) */
  primary: boolean;
}

export const QUICK_ACTIONS: QuickActionDef[] = [
  { id: 'myTasks', label: 'Mes tâches', icon: 'iconoirTaskList', primary: true },
  { id: 'createTask', label: 'Créer une tâche', icon: 'iconoirPlus', primary: true },
  { id: 'addToCalendar', label: 'Poser une présence', icon: 'iconoirCalendarPlus', primary: true },
  { id: 'assignTask', label: 'Assigner une tâche', icon: 'iconoirUserPlus', primary: true },
  { id: 'reserveRoom', label: 'Réserver une salle', icon: 'iconoirHouseRooms', primary: true },
  { id: 'createProject', label: 'Créer un projet', icon: 'iconoirFolderPlus', primary: false },
  { id: 'updateTaskStatus', label: 'Changer le statut', icon: 'iconoirRefreshDouble', primary: false },
  { id: 'deleteTask', label: 'Supprimer une tâche', icon: 'iconoirTrash', primary: false },
  { id: 'projectSummary', label: 'Résumé du projet', icon: 'iconoirGraphUp', primary: false },
  { id: 'commentTask', label: 'Commenter une tâche', icon: 'iconoirChatBubble', primary: false },
  { id: 'reportClaim', label: 'Réclamation matériel', icon: 'iconoirWarningCircle', primary: false }
];
